import { render, staticRenderFns } from "./homeOrderList.vue?vue&type=template&id=4b35abe6&scoped=true&"
import script from "./homeOrderList.vue?vue&type=script&lang=js&"
export * from "./homeOrderList.vue?vue&type=script&lang=js&"
import style0 from "./homeOrderList.vue?vue&type=style&index=0&id=4b35abe6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35abe6",
  null
  
)

export default component.exports